<template>
    <b-input-group class="w-100 bg-white">
        <b-input-group-prepend is-text>
            <i class="fa-solid fa-magnifying-glass"></i>
        </b-input-group-prepend>
        <b-form-input :style="inputStyle"
                      ref="queryInput"
                      v-model="localValue"
                      :placeholder="placeholder"
                      autofocus
                      @focus.native="$refs.queryInput.select()"
                      @keydown.enter.native="doQuery"></b-form-input>
        <b-input-group-append>
            <b-button variant="outline-success" @click="doQuery" :disabled="queryLoading || disable"
                      style="width: 70px">
                <b-spinner small v-if="queryLoading" type="grow"></b-spinner>
                <template v-else>Search</template>
            </b-button>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
export default {
    name: "SingleQueryInput",
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        frontSize: String,
        placeholder: String,
        disable: {
            type: Boolean,
            default: false
        },
        queryLoading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            localValue: ''
        }
    },
    computed: {
        inputStyle() {
            if (this.frontSize) {
                return `font-size: ${this.frontSize};`;
            }
            return '';
        },
    },
    methods: {
        doQuery() {
            this.$emit('update:value', this.localValue);
            this.$emit('doQuery', this.localValue);
        },
    }
}
</script>

<style scoped>

</style>
